import { IRootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { IUser } from "@/models/user";

export interface IUserProfileState {
    userInfo: IUser | null;
    isAutehnticated: boolean;
    error: any;
}

export const getDefaultUserState = (): IUserProfileState => {
    return {
        userInfo: null,
        isAutehnticated: false,
        error: null,
    };
};

// initial state
const state = getDefaultUserState();

const namespaced: boolean = true;

export const userProfile: Module<IUserProfileState, IRootState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
